export const BarcodeTypeOption = {
  Ean13: 0,
  Sscc18: 1,
  None: 2
};

export const DomainTypeOption = {
  Retailer: 0,
  InteriorDecorator: 1
};

export const GlAccountTypeOption = {
  ClientSales: 0,
  IntercompanySales: 1,
  IntercompanyPurchase: 2
};

export const FinishTypeOption = {
  Side: 0,
  Bottom: 1,
  Top: 2,
  Fixture: 3,
  Extra: 4,
  General: 5,
  Operation: 6
};

export const FixtureTypeOption = {
  Other: 0,
  Ring: 1,
  Loop: 2
};

export const OrderLineStatusOption = {
  New: 0,
  InProduction: 1,
  Ready: 2,
  Shipping: 3,
  Invoicing: 4
};

export const OrderLineSubStatusOption = {
  NoStock: 0,
  Selectable: 1,
  Preselected: 2,
  Selected: 3,
  Cancelled: 4,
  Printed: 5,
  Scanned: 6,
  Shipped: 7,
  InvoiceSent: 8,
  Loaded: 9,
  DeliveredDC: 10,
  DeliveredCustomer: 11,
  PlannedDateDeliveryCustomer: 12,
  ActualDateDeliveryCustomer: 13,
  InvoiceCreated: 14,
  Unprocessable: 15
};

export const ParityOption = {
  NotApplicable: 0,
  UpEven: 1,
  DownEven: 2,
  UpOdd: 3,
  DownOdd: 4
};

export const PlanningOption = {
  Panel: 0,
  NetCurtainRoomHigh: 1,
  CurtainRoomHigh: 2,
  RomanBlind: 3,
  Cutting: 4
};

export const PriceTypeOption = {
  SellingPrice: 0,
  ConsumerPrice: 1,
  PurchasePrice: 2,
  WorkshopPrice: 3
};

export const ProductGroupTypeOption = {
  Curtain: 0,
  RomanBlind: 1,
  NetCurtain: 2,
  Cutting: 3,
  Embrace: 4,
  PanelCurtain: 5,
  CushionCover: 6,
  BedLinen: 7,
  CurtainRoomHigh: 8
};

export const ProductTypeOption = {
  Fabric: 0,
  Ring: 1,
  Yarn: 2,
  RomanBlindCord: 3,
  WashingInstructions: 4,
  Fixture: 5,
  Other: 6,
  Chain: 7,
  WeightCord: 11
};

export const QuantityCalculationMethodOption = {
  NotApplicable: 0,
  Pleats: 1,
  Wave: 2,
  Formula: 3
};

export const QuantityPerOption = {
  ActualMetre: 0,
  FlatMetre: 1,
  Piece: 2,
  Panel: 3
};

export const RoundOption = {
  Standard: 0,
  Up: 1,
  Down: 2,
  None: 3
};

export const ReasonStockCorrectionOption = {
  ManualCorrection: 0,
  FabricOrderDelivery: 1,
  ReturnOrder: 2,
  Block: 5,
  OrderPick: 7,
  Transfer: 8
};

export const SpecialTypeOption = {
  Unspecified: 0,
  Tilted: 1
};

export const ParcelTypeOption = {
  Hanger: 0,
  RomanBlindBox: 1,
  CuttingPackage: 2,
  CuttingRole: 3
};

export const FabricTypeOption = {
  Panel: 0,
  RoomHigh: 1
};

export const FabricTypeOptionNames = {
  [FabricTypeOption.Panel]: 'Baanstof',
  [FabricTypeOption.RoomHigh]: 'Kamerhoog'
};

export const FabricOrderStatusOption = {
  Expected: 0,
  Delivered: 1,
  Confirmed: 2,
  Feedback: 3
};

export const FabricStatusOption = {
  New: 0,
  Active: 1,
  LastStock: 2,
  Discontinued: 3
};

export const TemplateImageTypeOption = {
  Finish: 0,
  ReturnOrder: 1,
  FabricDoNotIron: 2,
  FabricStaggeredPattern: 3
};

export const ExceedanceOption = {
  None: 0,
  NoStock: 1,
  NoLiningStock: 2,
  StockQuality: 3,
  Other: 4,
  Planning: 5
};

export const BottomHemChoiceOption = {
  DefaultHem: 0, // Standaard onderzoom
  NoHemLockAtHeight: 1, // Geen zoom, aflocken op hoogte
  NoHemNotLocked: 2, // Geen zoom, zo lang mogelijk
  InsideOut: 3 // Kamerkant andersom (d.w.z. binnenkant stof buiten, dus binnenste buiten)
};

export const PrintStatusOption = {
  Unattempted: 0,
  Queued: 1,
  Printed: 2,
  Failed: 3
};

export const PlanningInstallationServiceOption = {
  Regular: 0,
  Priority: 1,
  Exclude: 2
};
